module.exports = __webpack_public_path__ + "static/media/videoPreview4.d1708c52.mp4";